import { useState, useEffect } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { apiFetch } from '../lib/api';

export default function TermsOfService() {
  const [settings, setSettings] = useState<Record<string, string>>({});

  useEffect(() => {
    apiFetch<Record<string, string>>('/api/public/settings').then((res) => {
      if (res.success && res.data) setSettings(res.data);
    });
  }, []);

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <main className="py-12 px-4">
        <div className="container-max mx-auto max-w-3xl">
          <div className="bg-white rounded-2xl shadow-sm border border-brand-100 p-8 sm:p-10">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">{settings.termsTitle || '使用條款'}</h1>
            <p className="text-sm text-gray-500 mb-8">最後更新日期：{settings.termsDate || '2026年5月1日'}</p>

            <div className="space-y-6 text-gray-700 leading-relaxed text-sm">
              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">1. 接受條款</h2>
                <p>歡迎訪問「好餸傳愛．社區飯堂」網站（以下簡稱「本網站」）。通過使用本網站，您同意遵守以下使用條款。如您不同意任何條款，請立即停止使用本網站。</p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">2. 捐款條款</h2>
                <p>2.1 本網站接受的捐款均為自願性質，捐款一經確認將不設退款。</p>
                <p className="mt-2">2.2 捐款人應確保所提供的個人資料真實、準確及完整。</p>
                <p className="mt-2">2.3 捐款港幣 $100 或以上可獲發扣稅收據，收據將於捐款確認後 7 個工作天內發出。</p>
                <p className="mt-2">2.4 本機構保留拒絕任何可疑或欺詐性捐款的權利。</p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">3. 知識產權</h2>
                <p>3.1 本網站的所有內容，包括但不限於文字、圖片、標誌、影片及設計，均受版權保護。</p>
                <p className="mt-2">3.2 未經本機構書面許可，不得複製、修改、分發或以任何商業目的使用本網站內容。</p>
                <p className="mt-2">3.3 本網站使用的第三方商標及標誌均屬其各自擁有者所有。</p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">4. 免責聲明</h2>
                <p>4.1 本網站內容僅供參考，我們不保證內容的絕對準確性或完整性。</p>
                <p className="mt-2">4.2 本機構不對因使用或無法使用本網站而導致的任何直接、間接或後果性損失負責。</p>
                <p className="mt-2">4.3 本網站可能包含第三方網站的連結，我們不對這些網站的內容或安全性負責。</p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">5. 用戶行為</h2>
                <p>使用本網站時，您同意不會：</p>
                <ul className="list-disc list-inside mt-2 space-y-1 text-gray-600">
                  <li>從事任何非法或欺詐活動</li>
                  <li>干擾或破壞本網站的正常運作</li>
                  <li>未經授權存取本網站的後台系統</li>
                  <li>發送垃圾郵件或進行未經請求的商業推廣</li>
                  <li>上傳或傳播任何病毒、惡意軟件或有害內容</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">6. 帳戶安全</h2>
                <p>6.1 如您在本網站創建帳戶，您有責任保護您的登入憑證安全。</p>
                <p className="mt-2">6.2 您同意對使用您帳戶進行的所有活動負責。</p>
                <p className="mt-2">6.3 如您發現任何未經授權的帳戶使用，請立即通知我們。</p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">7. 條款修改</h2>
                <p>我們保留隨時修改這些使用條款的權利。任何修改將在本頁面發布後立即生效。建議您定期查閱本頁面以了解最新條款。</p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">8. 管轄法律</h2>
                <p>本使用條款受香港特別行政區法律管轄。任何因本條款引起的爭議，雙方同意接受香港法院的專屬管轄。</p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">9. 聯絡我們</h2>
                <p>如您對本使用條款有任何疑問，請聯絡我們：</p>
                <div className="mt-2 text-gray-600">
                  <p>電郵：{settings.contactEmail || 'eva@s2c.org.hk'}</p>
                  <p>電話：{settings.contactPhone || '+852 9466 3081'}</p>
                  <p>地址：{settings.contactAddress || '香港九龍深水埗'}</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
